exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal__descriptions[data-v-5fc71c0b] {\n  padding: 32px 24px;\n}\n.modal__text__title[data-v-5fc71c0b] {\n  white-space: pre-wrap;\n}\n", ""]);
